import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Item.types';
import { IItem } from './Item.lib';

export class Item extends IItem
{

    public static async create( id: number ): Promise<Item>
    {
        let o = new Item();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/pedidos/items';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Item>; Error?: boolean; }>
    {

        let a: Array<Item> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/pedidos/items` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Item( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    return this.set();
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    ComprobarTotales()
    {
        if ( this.Articulo )
            this.PrecioUnitario.AlicuotaIva = this.Articulo.AlicuotaIVA;
        else if ( !this.PrecioUnitario.AlicuotaIva )
            this.PrecioUnitario.AlicuotaIva = 0.21;

        if ( this.PrecioUnitario.Final && !this.PrecioUnitario.Neto )
        {
            this.PrecioUnitario.Neto = this.PrecioUnitario.Final / ( 1 + this.PrecioUnitario.AlicuotaIva );
        } else
        {
            this.PrecioUnitario.Final = this.PrecioUnitario.Neto * ( 1 + this.PrecioUnitario.AlicuotaIva );
        }

        this.Importes.Final = this.PrecioUnitario.Final * this.Cantidad;
        this.Importes.Neto = this.PrecioUnitario.Neto * this.Cantidad;
        this.Importes.IVA = this.PrecioUnitario.Final - this.PrecioUnitario.Neto;
    }
}